/** 마지막 자동 새로고침 시각(ms) — 같은 탭에서 짧은 시간 안에 되풀이되면 새 번들도 못 받는 것이라 멈춘다(무한 새로고침 방지). */
const RELOADED_AT_KEY = 'stale-chunk-reloaded-at';
const RETRY_COOLDOWN_MS = 10_000;

interface ReloadOnStaleChunkOptions {
  /** 시각 — 스펙이 바꿔 끼운다. */
  readonly now?: () => number;
  /** 새로고침 — 스펙이 바꿔 끼운다(jsdom 은 window.location 을 덮어쓸 수 없다). */
  readonly reload?: () => void;
}

/**
 * 배포 직후 열려 있던 화면이 지난 빌드의 조각(chunk)을 찾다 실패하면 새로고침한다.
 *
 * 화면은 에셋 이름(해시)을 가진 index.html 을 들고 있는데, 배포가 이름을 바꾸면 지연 로딩하는 페이지(약관 등)를 처음 열 때
 * "Failed to fetch dynamically imported module" 로 깨진다. Vite 는 이때 window 에 `vite:preloadError` 를 올린다 —
 * 기본 동작(오류 던지기)을 막고 새로고침해 새 index.html 을 받는다. 10초 안에 또 실패하면 기본 오류로 둔다.
 */
export const reloadOnStaleChunk = ({
  now = Date.now,
  reload = () => window.location.reload(),
}: ReloadOnStaleChunkOptions = {}): void => {
  window.addEventListener('vite:preloadError', (event) => {
    let recentlyReloaded = false;
    try {
      const last = Number(sessionStorage.getItem(RELOADED_AT_KEY));
      recentlyReloaded = Number.isFinite(last) && last > 0 && now() - last < RETRY_COOLDOWN_MS;
      if (!recentlyReloaded) sessionStorage.setItem(RELOADED_AT_KEY, String(now()));
    } catch {
      // 저장소를 못 쓰면(시크릿·차단) 그래도 한 번은 새로고침한다.
    }
    if (recentlyReloaded) return;
    event.preventDefault();
    reload();
  });
};
